<div class="card card-custom">
  <div class="card-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="doctorForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <kt-alert *ngIf="hasFormErrors" type="warn" [showCloseButton]="false" [duration]="10000">
        {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
      </kt-alert>
      <div class="form-group">
        <div class="row">
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.FIRST_NAME' | translate }}</mat-label>
              <input matInput formControlName="first_name" />
              <mat-error *ngIf="isControlHasError('first_name', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.LAST_NAME' | translate }}</mat-label>
              <input matInput formControlName="last_name" />
              <mat-error *ngIf="isControlHasError('last_name', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.EMAIL' | translate }}</mat-label>
              <input type="email" matInput formControlName="email" />
              <mat-error *ngIf="isControlHasError('email', 'email')">
                {{ 'AUTH.EMAIL' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.DEA' | translate }}</mat-label>
              <input matInput formControlName="dea" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.NPI' | translate }}</mat-label>
              <input matInput formControlName="npi" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.SLN' | translate }}</mat-label>
              <input matInput formControlName="sln" />
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
              <input matInput formControlName="urbanization" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.ADDRESS_1' | translate }}</mat-label>
              <input matInput formControlName="address_1" />
              <mat-error *ngIf="isControlHasError('address_1', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.ADDRESS_2' | translate }}</mat-label>
              <input matInput formControlName="address_2" />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.CITY' | translate }}</mat-label>
              <input matInput formControlName="city" />
              <mat-error *ngIf="isControlHasError('city', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.STATE' | translate }}</mat-label>
              <input matInput formControlName="state" maxlength="2" />
              <mat-error *ngIf="isControlHasError('state', 'pattern')">
                {{ 'AUTH.VALIDATION.INVALID_STATE' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.ZIP' | translate }}</mat-label>
              <input matInput formControlName="zip" maxlength="5" />
              <mat-error *ngIf="isControlHasError('zip', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
              <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                Zip Code is invalid
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.CELL_PHONE' | translate }}</mat-label>
              <input matInput formControlName="cell_phone" maxlength="14" ktAppPhoneMask />
              <mat-error *ngIf="isControlHasError('cell_phone', 'pattern')">
                {{ 'AUTH.VALIDATION.PATTERN' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.OFFICE_PHONE' | translate }}</mat-label>
              <input matInput formControlName="office_phone" maxlength="14" ktAppPhoneMask />
              <mat-error *ngIf="isControlHasError('office_phone', 'pattern')">
                {{ 'AUTH.VALIDATION.PATTERN' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.FAX' | translate }}</mat-label>
              <input matInput formControlName="fax" maxlength="14" ktAppPhoneMask />
              <mat-error *ngIf="isControlHasError('fax', 'pattern')">
                {{ 'AUTH.VALIDATION.PATTERN' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [label]="'Office'"
              [loadItemsFunction]="officeAutocompleteCall"
              [optionFormatter]="officeOptionFormatter"
              [valueFormatter]="officeOptionFormatter"
              [readOnly]="false"
              [control]="doctorForm.get('office_id')"
              [change]="onOfficeChange.bind(this)"
              [placeholder]="'Office'"
              #officeAutocompleteComponent
            ></kt-general-autocomplete>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.DOCTOR_ID' | translate }}</mat-label>
              <input matInput formControlName="doctor_id" maxlength="9" />
              <mat-error *ngIf="isControlHasError('doctor_id', 'required')">
                {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
              </mat-error>
              <mat-error *ngIf="isControlHasError('doctor_id', 'pattern')">
                Source System ID must be alphanumeric
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-3 kt-margin-bottom-20-mobile">
            <div class="mat-form-field-fluid">
              <mat-label class="row ml-1" translate="DOCTOR.INPUT.STATUS">Status</mat-label>
              <mat-slide-toggle
                class="mr-2"
                formControlName="is_active"
                disabled
              ></mat-slide-toggle>
              <mat-hint align="start">
                <strong>{{ getStatusString() }}</strong>
              </mat-hint>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            (click)="close()"
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="clicked"
            (click)="onSubmit()"
            matTooltip="Create"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
